import React, { Component } from "react";
import MaterialTable, { MTableCell, MTableBody } from "material-table";
import Modal from "@material-ui/core/Modal";
import MessagePopup from "../MessagePopup/MessagePopup";
import AdminMessagePopup from "../../pages/AdminDashboard/AdminMessages/AdminMessagePopup";
import OrderStatus from "../OrderStatus/OrderStatus";
import { Like, DisLike /* Message */ } from "../../assets/Icons";
/* import NotificationBadge from "react-notification-badge"; */
//IMAGES
import "./MatUITable.scss";

class MatUITable extends Component {
  constructor(props) {
    super(props);
    this.state = { dialogState: false, selectedRow: {} };
  }
  setSelectedRow(row) {
    this.setState({ dialogState: true, selectedRow: row });
  }
  handleClose() {
    this.setState({ dialogState: false });
  }
  setModalContent = (page) => {
    switch (page) {
      case "proposal":
        return (
          <MessagePopup
            content={this.state.selectedRow}
            proposal
            updateContent={() => this.updateRowData("_id")}
          />
        );
      case "support":
        return (
          <MessagePopup
            content={this.state.selectedRow}
            updateContent={() => this.updateRowData("threadID")}
          />
        );
      case "adminmessage":
        return (
          <AdminMessagePopup
            content={this.state.selectedRow}
            updateContent={() => this.updateRowData("threadID")}
            updateMessages={this.props.updateMessages}
          />
        );
      case "orders":
        return <OrderStatus content={this.state.selectedRow} />;
      default:
        return <></>;
    }
  };
  updateRowData = (ID) => {
    this.props.data.forEach((row) => {
      if (this.state.selectedRow[ID] === row[ID]) {
        this.setState({ selectedRow: row });
      }
    });
  };
  render() {
    return (
      <>
        <MaterialTable
          title=""
          columns={this.props.columns ? this.props.columns : []}
          data={this.props.data ? this.props.data : []}
          options={{
            headerStyle: {
              textAlign: "left",
              backgroundColor: "#FFFF",
              color: "#fe9929",
            },
            sorting: true,
            toolbar: false,
            search: false,
            pageSize: this.props.pageSize || 10,
            actionsColumnIndex: -1,
            paging: this.props.paging,
          }}
          onRowClick={(event, selectedRow) => {
            if (this.props.page === "proposal") {
              event.stopPropagation();
            } else if (
              this.props.page === "adminorders" ||
              this.props.page === "adminusers"
            ) {
              this.props.onRowClick(selectedRow);
            } else {
              this.setSelectedRow(selectedRow);
              this.setState({ dialogState: true });
            }
          }}
          actions={
            this.props.page === "proposal"
              ? [
                  (rowData) => ({
                    icon: () => {
                      return rowData.proposalstatus === "open" ? (
                        <img src={Like} alt="like" />
                      ) : null;
                    },
                    onClick: (event, rowData) => {
                      this.props.updateOrder(
                        rowData._id,
                        "accepted",
                        rowData.payment === "" ? "open" : rowData.payment
                      );
                      this.updateRowData(rowData._id);
                    },
                  }),
                  (rowData) => ({
                    icon: () => {
                      return rowData.proposalstatus === "open" ? (
                        <img src={DisLike} alt="like" />
                      ) : null;
                    },
                    onClick: (event, rowData) => {
                      this.props.updateOrder(rowData._id, "declined", "");
                      this.updateRowData(rowData._id);
                    },
                  }),
                  /*                   (rowData) => ({
                    icon: () => (
                      <div>
                        <NotificationBadge
                          style={{
                            minWidth: "none",
                            padding: "2px 4px",
                            fontSize: "10px",
                            top: "-12px",
                            right: "-10px",
                          }}
                          count={rowData.unseen}
                        />
                        <img src={Message} alt="like" />
                      </div>
                    ),
                    onClick: () => {
                      this.setState({
                        dialogState: true,
                        selectedRow: rowData,
                      });
                    },
                  }), */
                ]
              : []
          }
          components={{
            Cell: (props) => <MTableCell {...props} />,
            Body: (props) => (
              <MTableBody
                {...props}
                {...(props.localization.emptyDataSourceMessage = (
                  <>No data available</>
                ))}
              />
            ),
          }}
        />
        <Modal
          className="FlexCenter"
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.dialogState}
          onClose={() => this.handleClose()}
        >
          {this.setModalContent(this.props.page)}
        </Modal>
      </>
    );
  }
}
export default MatUITable;
